(() => {
  if (window.__metaxHomeColourSwitcherReady) return;
  window.__metaxHomeColourSwitcherReady = true;
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.metax-home-card__swatch');
    if (!swatch) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const card = swatch.closest('.metax-home-card');
    const image = card?.querySelector('.metax-home-card__image');
    const imageUrl = swatch.dataset.image?.trim();
    if (!card || !image || !imageUrl || !swatch.dataset.url) return;
    const requestId = String(Number(card.dataset.colourRequest || 0) + 1);
    card.dataset.colourRequest = requestId;
    const candidate = new Image();
    candidate.sizes = image.sizes || 'auto';
    candidate.srcset = swatch.dataset.srcset || '';
    candidate.onload = () => {
      if (card.dataset.colourRequest !== requestId || !card.isConnected) return;
      image.alt = swatch.dataset.title;
      image.sizes = candidate.sizes;
      image.srcset = candidate.srcset;
      image.src = imageUrl;
      card.querySelectorAll('.metax-home-card__image-link, .metax-home-card__info-link')
        .forEach(link => { link.href = swatch.dataset.url; });
      card.querySelector('.metax-home-card__model').textContent = swatch.dataset.model.trim();
      card.querySelector('.metax-home-card__price strong').textContent = swatch.dataset.price;
      const compare = card.querySelector('[data-metax-compare-price]');
      compare.textContent = swatch.dataset.comparePrice;
      compare.hidden = !swatch.dataset.comparePrice;
      const badge = card.closest('.metax-products__item')?.querySelector('[data-metax-discount]');
      if (badge) {
        const discount = Number(swatch.dataset.discount);
        badge.textContent = `-${discount}%`;
        badge.hidden = discount <= 0;
      }
      card.dataset.productId = swatch.dataset.productId;
      card.querySelectorAll('.metax-home-card__swatch').forEach(button => {
        const active = button === swatch;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    // A failed image keeps the previous image, URL, price and selection together.
    candidate.onerror = () => {};
    candidate.src = imageUrl;
  }, true);
})();
